import { EStudentPaymentStatus } from '@constants';
import { Popover, Space } from 'antd';
import { useState } from 'react';

import { StudentPaymentStatusTag } from '@/components/StudentPaymentStatusTag';
import { useMutateStudentPaymentStatus } from '@/store/users/user-info';

type Props = {
  userId: string;
  status: EStudentPaymentStatus;
};
export const PaymentStatus: React.FC<Props> = ({ status, userId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { updatePaymentStatus } = useMutateStudentPaymentStatus(userId);

  const handleStatusChange = (newStatus: EStudentPaymentStatus) => {
    if (newStatus === status) return;
    updatePaymentStatus(newStatus);
    setIsOpen(false);
  };

  const content = (
    <Space direction="vertical">
      {Object.values(EStudentPaymentStatus).map(paymentStatus => (
        <StudentPaymentStatusTag
          key={`${userId}-${paymentStatus}`}
          paymentStatus={paymentStatus}
          onClick={() => handleStatusChange(paymentStatus)}
        />
      ))}
    </Space>
  );
  return (
    <div onClick={e => e.stopPropagation()}>
      <Popover
        open={isOpen}
        onOpenChange={setIsOpen}
        content={content}
        placement="top"
        trigger="click">
        <span>
          <StudentPaymentStatusTag
            iconOnly
            paymentStatus={status}
            onClick={() => setIsOpen(!isOpen)}
          />
        </span>
      </Popover>
    </div>
  );
};
